const dayjs = require('dayjs')

export const getOfferValidToString = (
  isPreview,
  campaignEnd = null,
  market = null,
  overviewSubline = '',
  overviewSublineMarket = ''
) => {
  const offerValidToString = dayjs(campaignEnd).format('DD.MM.YYYY')

  const marketSubline = market?.address?.additionalAddress
    ? `${market.name} ${market?.address?.additionalAddress}`
    : market?.name

  const subline =
    market && !isPreview
      ? overviewSublineMarket
          .replace('$date', offerValidToString)
          .replace('$name', marketSubline)
      : market && isPreview
        ? overviewSublineMarket.replace('$name', marketSubline)
        : !isPreview
          ? overviewSubline.replace('$date', offerValidToString)
          : null

  return subline
}
